module.exports = __webpack_public_path__ + "img/normal.efbce763.jpg";